import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { StatisticsContext } from "@pages/Statistics/context";

import { setRegulationType } from "@store/regulation-type/actions";

import CustomErrorBoundary from "@components/Common/CustomErrorBoundary";
import TitleRow from "@components/Common/TitleRow";
import DownloadDropdown from "@components/Common/OldDownloadDropdown";

import RegulationCol from "./RegulationCol";
import StatisticsRegulationCol from "./StatisticsRegulationCol";
import SelectWrapper from "@components/Common/SelectWrapper";

export default function RegulationRow() {
    const { t } = useTranslation();

    const period = useSelector((state: any) => state.period);
    const advancedDate = useSelector((state: any) => state.advancedDate);
    const selections = useSelector((state: any) => state.selections);
    const type = useSelector((state: any) => state.type);
    const regulationType = useSelector(
        (state: RegulationTypeType) => state.regulationType
    );

    const [percentageData, setPercentageData] = React.useState<any[]>([]);
    const [histogramData, setHistogramData] = React.useState<any[]>([]);
    const [categoriesData, setCategoriesData] = React.useState<any[]>([]);

    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setRegulationType(t("All regulation methods")));
    }, [dispatch, t]);

    return (
        <React.Fragment>
            <StatisticsContext.Provider
                value={{
                    period,
                    type,
                    advancedDate,
                    selections,
                    percentageData,
                    setPercentageData,
                    histogramData,
                    setHistogramData,
                    categoriesData,
                    setCategoriesData,
                }}
            >
                <TitleRow title={regulationType}>
                    {[
                        t("All regulation methods"),
                        t("Physical Payment Method"),
                        t("Digital Payment Method"),
                    ].includes(regulationType) && (
                        <SelectWrapper
                            options={[
                                t("All regulation methods"),
                                t("Digital Payment Method"),
                                t("Physical Payment Method"),
                            ]}
                        />
                    )}
                    <DownloadDropdown />
                </TitleRow>
                <div
                    className="d-grid__clz 
            grid-gap__clz 
            grid-xl-statistics-template-col__clz 
            grid-lg-statistics-template-col__clz
            grid-statistics-template-col__clz 
            grid-sm-template-col__clz 
            grid-xs-template-col__clz"
                >
                    <CustomErrorBoundary>
                        <RegulationCol />
                    </CustomErrorBoundary>
                    <CustomErrorBoundary>
                        <StatisticsRegulationCol />
                    </CustomErrorBoundary>
                </div>
            </StatisticsContext.Provider>
        </React.Fragment>
    );
}
